module.exports = __webpack_public_path__ + "img/Background_gold.93bfb5ad.png";